import React, { Component } from 'react'
import { connect } from 'react-redux'
// import { fetchCollection } from '../../common/redux/collectionActions'
// import MyLoader from '../../common/components/MyLoader'
import { Grid, Row, Col, OverlayTrigger, Tooltip, Glyphicon } from 'react-bootstrap'

var formatter = new Intl.NumberFormat('en-IT', {
    minimumFractionDigits: 2
})

const defaultProps = {
    deliveries: []
}

class ExploreLock extends Component {
    constructor(p) {
        super(p)
    }

    isLoading = () => {
        const { deliveries } = this.props
        const { deliveryOccasions } = this.props.dataAnalytics

        if (!deliveryOccasions || !Object.keys(deliveryOccasions).length) return true
        if (!deliveries) return true

        return false
    }

    generateStatisticsList = () => {
        const items = []
        const { deliveries } = this.props
        const { deliveryOccasions } = this.props.dataAnalytics

        if (!deliveryOccasions) return

        const lock = deliveryOccasions[this.props.lock._id] || { deliveryOccasionsQty: 0 }

        if (deliveryOccasions && Object.keys(deliveryOccasions).length) items.push({ text: `Antal mottagna leveranser`, value: lock.deliveryOccasionsQty || 0 })

        items.push({ text: `Antal mottagna paket`, value: lock.deliveryQty || 0 })

        return (
            <ol style={{ listStyleType: 'none' }}>
                {items.map((i, ii) => {
                    return (
                        <li key={ii}>{i.text}: <b>{i.value}</b></li>
                    )
                })}
            </ol>
        )
    }

    generateSavingsList = () => {
        const items = []
        const { deliveries } = this.props //FIXME: SKA VI HA DETTA?
        const { deliveryOccasions } = this.props.dataAnalytics

        if (!deliveryOccasions) return

        const lock = deliveryOccasions[this.props.lock._id] || { deliveryOccasionsQty: 0 }

        // if (deliveryOccasions) items.push({ text: `Kronor sparade på att inte behöva möta leveransbudet`, value: Math.ceil((1000 * 0.33333) * 700) })
        if (deliveryOccasions) items.push({ text: `Kronor sparade på att inte behöva möta leveransbudet`, value: Math.ceil((lock.deliveryOccasionsQty * 0.33333) * 700) })

        // items.push({ text: `Antal mottagna paket`, value: deliveries.filter(d => d.to_lock === this.props.lock._id).length })

        return (
            <ol style={{ listStyleType: 'none' }}>
                {items.map((i, ii) => {
                    return (
                        <li key={ii}>{i.text}: <b>{formatter.format(i.value).replace('.00', '')} kr</b></li>
                    )
                })}
            </ol>
        )
    }

    render() {
        const { lock, selected, deliveries } = this.props

        return (
            <div style={{ padding: 15, borderRadius: 20, boxShadow: 'grey 1px 1px 5px', backgroundColor: 'white' }}>
                <div id={lock._id} style={{ position: 'absolute', marginTop: -400 }}></div>

                <div style={{ textAlign: 'right' }}>
                    {this.isLoading() ? 'Laddar statistik' : null} &nbsp;
                </div>

                <div style={{ textAlign: 'center' }}>
                    <span style={{ color: '#006e78', fontWeight: 'bold' }}>{lock.custom_name} - {lock.address.street}, {lock.address.zip} {lock.address.city}</span>
                </div>


                <div>
                    <div>
                        <span style={{ color: '#006e78', fontWeight: 'bold' }}>Statistik för valt tidsintervall ({this.props.noDays} dagar):</span>
                    </div>

                    <br />

                    <div style={{}}>
                        {this.generateStatisticsList()}
                    </div>

                    <br />

                    <div>
                        <span style={{ color: '#006e78', fontWeight: 'bold' }}>Beräknat sparande för valt tidsintervall ({this.props.noDays} dagar):</span>
                    </div>

                    <br />



                    <div>
                        {this.generateSavingsList()}
                        <br />
                    </div>
                </div>
                <br />
                <div>
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">En arbetsledare kostar i snitt 700kr/timme och mätningar som Qlocx gjort tillsammans med sina kunder visar att tidsbesparingen med en leveranscontainer är ~20 minuter per leveranstillfälle.</Tooltip>}>
                        <span className="d-inline-block">
                            <Glyphicon glyph="glyphicon glyphicon-question-sign"></Glyphicon>
                        </span>
                    </OverlayTrigger>
                </div>
            </div>
        )
    }
}

ExploreLock.defaultProps = defaultProps

const mapProps = state => {
    return {
        dataAnalytics: state.dataAnalytics,
        deliveries: state.collectionData.deliveries
    }
}

const mapDispatch = dispatch => {
    return {}
}

export default connect(mapProps, mapDispatch)(React.memo(ExploreLock))